
export default {
  layout: 'technos',
  mounted() {
    new RDStationForms(
      'inscricoes-technos-440020e5bde67041bc99',
      'UA-228576147-2'
    ).createForm()
  },
}
